import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {readMemberEnablePages, resolveMemberRoute} from './member-page-access.policy';

@Injectable({providedIn: 'root'})
export class MemberPageGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isMember = localStorage.getItem('isMember') === 'true';
    if (!isMember) return true; // admins/support pass through

    const currentPath = route.routeConfig?.path || '';
    const decision = resolveMemberRoute(currentPath, readMemberEnablePages());
    if (decision.allowed) return true;

    // redirectTo est garanti non bouclant par la policy (cf. #4965) : jamais la
    // route protégée courante elle-même.
    this.router.navigate([decision.redirectTo]);
    return false;
  }
}
